import PromptModal from "./PromptModal"

export default  PromptModal;
